import React, { useState, useEffect, useRef, useMemo } from 'react';

import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Message } from 'primereact/message';

import { translatedMessage } from '../../../service/LanguageService';
import LanguageListComponent from '../../../components/profile/LanguageListComponent';
import { ApplicationService } from '../../../service/ApplicationService';
import useAuth from '../../../hooks/useAuth';
import FieldEvaluationDropdownComponent from '../../../components/evaluation/FieldEvaluationDropdownComponent';

const ApplicationLanguage = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [languageList, setLanguageList] = useState(null);
    const [pageTitle, setPageTitle] = useState(translatedMessage("profile.language"));
    const [pageSubTitle, setPageSubTitle] = useState(null);
    const [languageRequirement, setLanguageRequirement] = useState('');
    const [fieldEvaluation, setFieldEvaluation] = useState(null);
    const [mandatory, setMandatory] = useState(false);

    const toast = useRef(null);
    const { auth } = useAuth();

    const applicationService = useMemo(() => new ApplicationService(), []);

    useEffect(() => {
        setIsLoading(true)

        const getLanguageRequirement = () => {
            if (props?.formFields && props?.formFields.length > 0) {
                props.formFields.forEach(item => {
                    if (item.formField.field.code === 'limbiStaine') {
                        setPageTitle(item.formField.field.label)
                        setPageSubTitle(item.formField.field.preDescription)
                        setLanguageRequirement(item.formField.requestedValue)
                        setMandatory(item.formField.mandatory)
                    }
                })
            }
        }

        const getLanguageList = async () => {
            await applicationService.getApplicationLanguage(props?.application.id)
                .then(languageRespone => {
                    setLanguageList(languageRespone)
                })
                .catch(error => {
                    toast.current.show({ severity: 'error', summary: translatedMessage(error), life: 5000 })
                })
        }

        const getEvaluation = () => {
            if (props?.isForEvaluation && props?.evaluation?.fieldsEvaluation) {
                props?.evaluation?.fieldsEvaluation.forEach(item => {
                    if (item.applicationFormField.formField.field.code === 'limbiStaine') {
                        setFieldEvaluation(item)
                    }
                })
            }
            setIsLoading(false)
        }

        getLanguageRequirement()
        getLanguageList()
        getEvaluation()
    }, [applicationService, props]);

    const onFieldEvaluationChange = (applicationFieldEvaluationId, comment, status) => {
        let _fieldEvaluation = fieldEvaluation
        _fieldEvaluation.status = status;
        _fieldEvaluation.comment = comment;

        setFieldEvaluation({ ..._fieldEvaluation })
    };

    if (isLoading) {
        return (
            <div className='w-full flex align-items-center'>
                <Toast ref={toast} />
                <ProgressSpinner />
            </div>
        );
    } else {
        let canBeEdited = props?.isCommitteeActive && fieldEvaluation?.evaluation?.evaluationCommitteeUser?.user?.id === auth.user.id && !props?.viewOnly

        return (
            <>
                <Toast ref={toast}></Toast>

                <div className='w-full text-align-left mb-0'>
                    <h5 className='mb-1'>{pageTitle}</h5>
                    {pageSubTitle &&
                        <div className='mb-1 font-italic'>{pageSubTitle}</div>
                    }
                    {!props?.hideFillInExpanation &&
                        <div>
                            <Message severity="warn" text={translatedMessage("application.language.info")} />
                            {/* <div className='mt-1'>{translatedMessage("application.language.info2")}</div> */}
                        </div>
                    }

                    <div className='mt-2'>
                        <span className='font-bold'>{translatedMessage("form.field.requestedValue.description") + " "}</span>
                        {languageRequirement ? languageRequirement : "-"}
                    </div>

                    {props?.isForEvaluation &&
                        <>
                            <h5 className='mb-1'>{translatedMessage("evaluation.evaluation")}</h5>
                            <div className="w-full grid pcn-data-view-panel">
                                <div className='col-12 pb-0 p-fluid'>
                                    <div className="filed-label">{translatedMessage('generic.status')}</div>
                                    <FieldEvaluationDropdownComponent
                                        applicationFieldEvaluation={fieldEvaluation}
                                        afterSave={onFieldEvaluationChange}
                                        statusOptions={props?.statusOptions}
                                        canBeEdited={canBeEdited}
                                    />
                                </div>
                            </div>
                        </>
                    }
                </div>

                <LanguageListComponent
                    language={languageList}
                    isForApplication={true}
                    application={props?.application}
                    onListUpdate={(list) => setLanguageList(list)}
                    updateFields={props?.updateFields}
                    mandatory={mandatory}
                />
            </>
        );
    }
};

export default ApplicationLanguage;
